import { useDispatch, useSelector } from "react-redux";
import { setIsOpenFaqDragable } from "../../../../../actions";

export const useHeader = () => {
  const isOpenFaqDragable = useSelector(
    (state) => state.isOpenFaqDragableReducer
  );
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setIsOpenFaqDragable(false));
  };

  return { isOpenFaqDragable, handleClose };
};
